import type { ListingsByTypeQueryParams } from "./resources/Listings";

/** Shared paginated list params for Tourismo API fetches and React Query keys. */
export const LIST_PER_PAGE = 100;

export const listParams = { per_page: LIST_PER_PAGE } as const;

/** Map page: all geolocated listings grouped by type. */
export const mapListingsParams = { limit: 200 } satisfies ListingsByTypeQueryParams;
